import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { BackWarningModal } from 'ui/components/common';
import useModal, { useExternalModal } from 'ui/partials/Modal/useModal';
import useAdminParams from 'utils/helpers/useAdminParams';

interface PROPS {
  isDirty: boolean;
  item: string;
  path?: string;
}

export default function useFormWarning({ isDirty, path, item }: PROPS) {
  const { hideModal: hideMainModal } = useModal();
  const { showModal, hideModal } = useExternalModal();
  const navigate = useNavigate();
  const { relativePath } = useAdminParams();

  const onBack = () => {
    const onBack = () => {
      if (path) {
        navigate(`${relativePath ?? '/'}${path}`);
      } else {
        hideMainModal();
      }
    };

    if (isDirty) {
      showModal({
        title: 'Discard changes?',
        content: (
          <BackWarningModal
            item={item}
            onGoBack={() => {
              onBack();
              hideMainModal();
              hideModal();
            }}
          />
        ),
      });
    } else {
      onBack();
    }
  };

  useEffect(() => {
    if (!isDirty) return;

    window.history.pushState(null, '', window.location.pathname);

    const handleWindowClose = (e: BeforeUnloadEvent) => {
      if (!isDirty) return;

      e.preventDefault();

      return (e.returnValue = 'Are you sure you want to leave?');
    };

    const handlePopState = () => {
      const leave = window.confirm('Are you sure you want to leave?');

      if (!leave) {
        window.history.pushState(null, '', window.location.pathname);
      } else {
        window.history.back();
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleWindowClose);

    return () => {
      window.removeEventListener('beforeunload', handleWindowClose);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isDirty, relativePath]);

  return { onBack };
}
